export default "__VITE_ASSET__0vOlmQie__"